import { Link } from 'react-router-dom';

interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  description?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionTitle({ eyebrow, title, description, linkTo, linkLabel }: SectionTitleProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-label font-medium tracking-wide uppercase text-accent-600 mb-2">
            <span className="w-4 h-[2px] bg-accent-500 rounded-full"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="text-xl md:text-3xl font-bold text-foreground-950">
          <Link to={linkTo || '#'}>{title}</Link>
        </h2>
        {description && <p className="mt-2 text-sm text-foreground-600 max-w-2xl">{description}</p>}
      </div>
      {linkTo && linkLabel && (
        <Link
          to={linkTo}
          className="inline-flex items-center gap-1.5 text-sm text-primary-700 hover:text-primary-600 whitespace-nowrap shrink-0"
        >
          {linkLabel}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      )}
    </div>
  );
}